module.exports = __webpack_public_path__ + "static/world-9196279afe3d8b703f117e50e2fd35d5.svg";